import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "h-full w-1 transition group-hover:bg-gray-400" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

import { useDraggable } from "@vueuse/core/index";
import { PropType, Ref, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitValuesEditorTagsSlider',
  props: {
  containerRef: {
    type: Function as PropType<() => Ref<HTMLDivElement | null>>,
    required: true,
  },
  currentX: {
    type: Number,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
},
  emits: ["moved", "started", "ended"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slider = ref<HTMLElement | null>(null);
const initialX = ref(0);

const setBodyUserSelect = (value: string) => {
  window.document.body.style.userSelect = value;
  // for Safari
  window.document.body.style["webkitUserSelect"] = value;
};

useDraggable(slider, {
  axis: "x",
  containerElement: props.containerRef(),
  initialValue: () => ({ x: props.currentX, y: 0 }),
  onStart: (position) => {
    initialX.value = position.x;
    setBodyUserSelect("none");
    emit("started");
  },
  onEnd: () => {
    setBodyUserSelect("auto");
    emit("ended");
  },
  onMove: (position) => {
    const container = props.containerRef().value;
    if (container) {
      const containerRect = container.getBoundingClientRect();
      const x = position.x - containerRect.x + initialX.value;
      emit("moved", x);
    }
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex justify-center items-center group cursor-[col-resize]",
    style: _normalizeStyle(`position: absolute; top: 0; bottom: 0; left: ${__props.currentX}px; width: ${__props.width}px; transform: translateX(-50%); z-index: 999999`),
    ref_key: "slider",
    ref: slider
  }, _hoisted_2, 4))
}
}

})